import { debounce } from "../utils/debounce.js";

export const header = {
    lastScroll: 0,
    headerBands: document.querySelector(".header__bands"), //header__bands contient header__contact--mobile + js-header-nav
    headerNav: document.querySelector(".header__nav"),
    headerContact: document.querySelector(".header__contact--mobile"),
    headerBandsHeight: null,
    headerNavHeight: null,
    headerContactHeight: null,
    windowWidth: null,
    init: () => {
        header.headerNavHeight = parseInt(window.getComputedStyle(header.headerNav).height);
        header.headerContactHeight = parseInt(window.getComputedStyle(header.headerContact).height);
        header.headerBandsHeight = header.headerNavHeight + header.headerContactHeight;
        header.windowWidth = window.innerWidth;
        window.addEventListener(
            // récupérer la hauteur de la nav qui peut changer selon la largeur de la fenêtre (@mediaquery)
            "resize",
            debounce(() => header.recalculateHeaderHeight(), 500)
        );
        window.addEventListener("scroll", header.handleScroll, { passive: true });

        const dropdownTriggerBtns = document.querySelectorAll(".dropdown__trigger");
        dropdownTriggerBtns.forEach((el) => {
            el.addEventListener("click", (e) => {
                // Empecher au clic sur le lien trigger du dropdown de remonter en haut de la page
                e.preventDefault();
            });
        });
    },

    recalculateHeaderHeight: () => {
        if (!header.windowWidth) return;
        if (header.windowWidth !== window.innerWidth) {
            header.headerNavHeight = parseInt(window.getComputedStyle(header.headerNav).height);
            header.headerContactHeight = parseInt(window.getComputedStyle(header.headerContact).height);
            header.headerBandsHeight = header.headerNavHeight + header.headerContactHeight;
        }
    },

    handleScroll: () => {
        if (!header.headerBands || !header.headerBandsHeight) return;
        const dropdownMenus = document.querySelectorAll(".dropdown__menu");

        let currentScroll = window.scrollY;
        if (currentScroll < header.headerBandsHeight) {
            return;
        }
        if (currentScroll <= 0) {
            header.headerBands.classList.remove("scroll-up");
            return;
        }
        if (currentScroll > header.lastScroll) {
            dropdownMenus.forEach((dropdown) => {
                dropdown.classList.remove("show");
            });
            header.headerBands.classList.add("scroll-down");
            header.headerBands.classList.remove("scroll-up");
        }
        if (currentScroll < header.lastScroll) {
            header.headerBands.classList.add("scroll-up");
            header.headerBands.classList.remove("scroll-down");
        }
        header.lastScroll = currentScroll;
    },
};
